import React from 'react';
import { ContFirstFormContact } from './FormContact.styles';
import PipedriveContactForm from './PipedriveContactForm';

export const FormContact = () => (
  <ContFirstFormContact id="ContFirstFormContact">
    <PipedriveContactForm />
  </ContFirstFormContact>
);
